<template>
  <a id="ProductPersonality" />
  <div class="ProductPersonality desktopMaxW-lg grid grid-cols-1 desk:grid-cols-2 gap-48 desk:gap-96 mb-48 desk:mb-96">
    <div class="flex flex-col gap-24">
      <!-- Name & Description -->
      <div class="flex flex-col gap-12">
        <div class="type-headline-xl">{{ $t('personality.headline') }}</div>
        <div class="type-headline-lg text-text-subtle">
          {{ activeVariant.variantDescription }}
        </div>
      </div>

      <!-- USP -->
      <div class="flex flex-col gap-8 desk:gap-12 bg-bg-brandSubtle p-12 desk:p-16 type-base rounded-2">
        <div class="type-headline-base">{{ $t('personality.features') }}</div>
        <ul class="flex flex-col gap-8 desk:gap-12">
          <li
            v-for="chip in chips"
            :key="chip.code"
            class="inline-flex items-center gap-8"
          >
            <img
              v-if="chip.image !== ''"
              :src="chip.image"
              :alt="chip.name"
              class="w-20 h-20"
            >
            {{ chip.name }}
          </li>
        </ul>
      </div>
    </div>

    <!-- Stats -->
    <ul class="flex flex-col gap-24 desk:gap-32 text-text-subtle">
      <li
        v-for="parametric in usedParametrics"
        :key="parametric.code"
        class="flex items-center gap-16 desk:gap-20"
      >
        <img
          :src="`/icons/personality/${parametric.code}.svg`"
          :alt="parametric.name"
          class="w-32 h-32 desk:w-40 desk:h-40"
        >
        <div class="grow flex flex-col gap-6">
          <div class="type-tagline">{{ parametric.name }}</div>
          <div class="bg-bg-brandStrong relative w-full h-2 rounded-full">
            <div
              class="absolute top-half -translate-x-half -translate-y-half w-12 h-12 inline-flex justify-center items-center rounded-full bg-bg-successStrong"
              :title="parametric.valueName"
              :style="{
                left: `${parametric.value}%`
              }"
            >
              <div class="w-8 h-8 rounded-full bg-surface-base inline-flex justify-center items-center">
                <div class="w-4 h-4 rounded-full bg-bg-successStrong"/>
              </div>
            </div>
          </div>
          <div class="flex items-center justify-between type-sm gap-12">
            <div>{{ $t(`dyn.personality.${parametric.code}.min`) }}</div>
            <div class="text-right">{{ $t(`dyn.personality.${parametric.code}.max`) }}</div>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { ProductModel } from '~/models/product';
import { ProductVariantModel } from '~/models/productVariant';
import Tooltip from '~/components/body/Tooltip.vue';
import { computed } from 'vue';

const props = defineProps<{
  productItem: ProductModel;
  activeVariant: ProductVariantModel,
}>();

const usedParametrics = computed(()=> {
  const output = props.activeVariant.parametrics.filter(f => f.groupCode === 'B2CPersonalityValueMatrix').map(m => {
    return {
      name: m.name,
      code: m.code,
      value: m.listValue?.code || null,
      valueName: m.listValue?.name || '',
    };
  });
  return output.filter(f => f.value !== null);
});

const chips = computed(()=> {
  return props.activeVariant.parametricByCode('B2CChips')?.multipleValues || [];
});

</script>

<style scoped lang="postcss">
</style>
